import { z } from 'zod';
import { freeformBodySchema } from './freeform-body.schema';
import { HeadObjectSchema } from 'services/generic';

export const getByUrlSchema = z.object({
    id: z.string(),
	url: z.string(),
	language: z.string(),
	siteMap: z.boolean(),
	changeFrequency: z.string(),
	head: HeadObjectSchema,
	body: freeformBodySchema,
	dateModified: z.string(),
	timestamp: z.number(),
	template: z.string(),
	isPrivate: z.boolean(),
});
